import CapabilitiesEditorSubmitButtonText from './CapabilitiesEditorSubmitButtonText';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * @description The default submit button for sending
 * replies. It has some edge casing for email behavior that
 * should eventually be made generic to support any channel
 * that allows sending to multiple recipients.
 */
const ReplySubmitButton = ({
  disabled,
  onClick,
  genericChannelId = 'UNSET',
  buttonRef,
  recipientCount = 0
}) => {
  return /*#__PURE__*/_jsx(Button, {
    disabled: disabled,
    onClick: onClick,
    buttonRef: buttonRef,
    use: "primary",
    size: "small",
    "data-test-id": "composer-send-button",
    children: /*#__PURE__*/_jsx(CapabilitiesEditorSubmitButtonText, {
      editorConfigurationKey: genericChannelId,
      count: recipientCount
    })
  });
};
ReplySubmitButton.displayName = 'ReplySubmitButton';
export default ReplySubmitButton;